import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import Sidebar from "../../component/sidebar";
import Header from "../../component/header";
import Controls from "../forms/controls/Controls";
import { useForm, Form } from "../forms/useForm";
import { useGetImageGallerysByIdQuery } from "../../../../services/imageGallerySlice";
import BlobToFile from "../forms/utils/blobToFile";
import { useUpdateImageGalleryMutation } from "../../../../services/imageGallerySlice";
import urlToFile from "../forms/utils/urlToFile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faBell,
  faSignInAlt,
  faExclamationTriangle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const ImageGalleryEditPage = () => {
  return (
    <Grid container className="dashboard-full-background">
      <Grid item xs={2} spacing={4}>
        <Sidebar />
      </Grid>
      <Grid item xs={10}>
        <Header />
        <EditImageGalleryPages />
      </Grid>
    </Grid>
  );
};

const EditImageGalleryPages = () => {
  const { id } = useParams();
  const ImageGallerys = useGetImageGallerysByIdQuery(id);
  const [File, setFile] = useState([]);
  const [updateImageGallery, setUpdateImageGallery] = useState([]);
  const [initialFValues, setInitialFValues] = useState({
    image: [],
    is_active: "false",
  });
  const [SuccessMessege, setSuccesMessege] = useState(null);
  const [ErrorMessege, setErrorMessege] = useState(null);
  const history = useNavigate();

  useEffect(() => {
    console.log(ImageGallerys.data);
    if (ImageGallerys.data) {
      if (ImageGallerys.data.image) {
        urlToFile(ImageGallerys.data.image, setFile);
      }

      setInitialFValues({
        image: File,
        is_active: ImageGallerys.data.is_active.toString(),
      });
    }
  }, [ImageGallerys.data]);

  const { values, handleImageUpload, handleInputChange } = useForm(
    initialFValues,
    true,
    false,
    true
  );

  const [editImageGallery] = useUpdateImageGalleryMutation();

  useEffect(() => {
    handleImageUpload("image", File);
  }, [File]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    var file = BlobToFile(values.image, "imageGallery");
    var isTrueSet = values.is_active === "true";
    if (file.length !== 0) {
      formData.append("image", file, "imageGallery.jpg");
    }
    formData.append("is_active", isTrueSet);
    formData.append("id", id);
    editImageGallery(formData)
      .then((res) => {
        setSuccesMessege("Successfully Updated Gallery Images Data.");
        setTimeout(() => {
          window.location.reload();
          history("/dashboard/home");
        }, [3000]);
      })
      .catch((err) => {
        setErrorMessege("Some Error Occur. Please Try Again Later.");
        setTimeout(() => {
          setErrorMessege(null);
        }, [3000]);
      });
  };

  return (
    <Box className="table-design-background">
      <Typography className="dashboard-home-page-text">
        Update Gallery List
      </Typography>
      <Box style={{ padding: "1.5rem", paddingLeft: "0rem" }}>
        <Form onSubmit={handleSubmit}>
          <Grid container>
            <Grid item xs={6}>
              <Controls.Image setFile={setFile} />
            </Grid>
            <Grid item xs={6}>
              <Controls.RadioGroup
                name="is_active"
                label="Is Active"
                value={values.is_active}
                onChange={handleInputChange}
                items={[
                  { id: "false", title: "False" },
                  { id: "true", title: "True" },
                ]}
              />
            </Grid>
            <Grid style={{ paddingLeft: "1.5rem" }}>
              <Controls.Button
                type="submit"
                text="Submit"
                backgroundColor="#1b284b"
                onClick={handleSubmit}
              />
            </Grid>
          </Grid>
        </Form>
        {SuccessMessege === null ? null : (
          <Box className="successmessege">
            <Typography className="messegefonts">
              <FontAwesomeIcon icon={faCheckCircle} className="messegeicon" />
              {SuccessMessege}
            </Typography>
          </Box>
        )}
        {ErrorMessege === null ? null : (
          <Box className="errormessege">
            <Typography className="messegefonts">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                className="messegeicon"
              />
              {ErrorMessege}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ImageGalleryEditPage;
